import axios from 'axios';
import handleApiError from '../api/apiErrorHandler';
import { logger } from '../utils/logger';
import { CONSTS } from '../const';
import { checkForRedirect, redirectToLogin } from '../contexts/AuthContext';
import { getCsrfTokenFromCookies } from '../utils/csrf';

let refreshTokenPromise = null;

const createAxiosClient = (accessToken, navigate) => {
  const customRequest = async (
    query,
    variables = {},
    isMultipart = false,
    retry = false
  ) => {
    try {
      let requestData;
      const { csrfTokenKey, csrfToken } = getCsrfTokenFromCookies();
      let headers = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        [csrfTokenKey]: csrfToken || '',
      };

      if (isMultipart) {
        logger.log('variables before', variables);
        requestData = new FormData();
        const orgvar = JSON.parse(JSON.stringify(variables));
        orgvar.files = [null, null];

        logger.log('variables', variables);
        requestData.append(
          'operations',
          JSON.stringify({ query, variables: orgvar })
        );
        logger.log('orgvar', orgvar);
        const map = {};
        let index = 0;

        if (variables.files) {
          for (const key in variables.files) {
            if (variables.files[key]) {
              map[index] = [`variables.files.${key}`];
              requestData.append(index.toString(), variables.files[key]); // Correctly append file
              index++;
            }
          }
        }

        logger.log('map', map);
        requestData.append('map', JSON.stringify(map));

        logger.log('FormData Debugging:');
        for (const pair of requestData.entries()) {
          logger.log(
            pair[0],
            typeof pair[1] === 'object' ? JSON.stringify(pair[1]) : pair[1]
          );
        }
        logger.log('requestData', requestData);
        headers['Content-Type'] = 'multipart/form-data';
      } else {
        requestData = { query, variables };
        headers['Content-Type'] = 'application/json';
      }

      const response = await axios.post(
        `${process.env.REACT_APP_ONBOARDING_API_ENDPOINT}/graphql`,
        requestData,
        { headers, withCredentials: true }
      );

      const resp = response.data;
      logger.log('Middleware Response:', response);
      if (resp.errorCode == 'SESSION_EXPIRED') {
        redirectToLogin();
      }

      // GraphQL returns HTTP 200 with errors[].extensions.statusCode for auth issues
      const gqlStatusCode = resp?.errors?.[0]?.extensions?.statusCode;
      if (gqlStatusCode == CONSTS.EXPIRED_STATUS_CODE) {
        if (!retry) {
          if (!refreshTokenPromise) {
            refreshTokenPromise = checkForRedirect(gqlStatusCode).finally(() => {
              refreshTokenPromise = null;
            });
          }
          const isTokenRefreshed = await refreshTokenPromise;
          if (isTokenRefreshed) {
            return customRequest(query, variables, isMultipart, true);
          }
        }
      }
      if (gqlStatusCode == CONSTS.UNAUTHORIZED_STATUS_CODE) {
        checkForRedirect(gqlStatusCode);
      }

      if (resp.data && !resp.errors) {
        return resp.data;
      }
      throw resp;
    } catch (error) {
      logger.error('Query execution error:', error);
      if (error?.status == CONSTS.EXPIRED_STATUS_CODE) {
        if (!retry) {
          if (!refreshTokenPromise) {
            refreshTokenPromise = checkForRedirect(error.status).finally(() => {
              refreshTokenPromise = null;
            });
          }
          const isTokenRefreshed = await refreshTokenPromise;
          logger.debug('isTokenRefreshed', isTokenRefreshed);
          if (isTokenRefreshed) {
            return customRequest(query, variables, isMultipart, true);
          }
        }
      } else if (error?.status == CONSTS.UNAUTHORIZED_STATUS_CODE) {
        checkForRedirect(error?.status);
      } else {
        handleApiError(error);
      }
    }
  };

  return { request: customRequest };
};

export default createAxiosClient;
